"use client";

import Image from "next/image";
import { useEffect, useRef, useState } from "react";

export function HeroSection() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [isSized, setIsSized] = useState(false);
  const paragraphRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    // Initial check
    checkDesktop();

    window.addEventListener("resize", checkDesktop);
    return () => {
      window.removeEventListener("resize", checkDesktop);
    };
  }, []);

  useEffect(() => {
    if (paragraphRef.current) {
      if (isDesktop) {
        paragraphRef.current.style.fontSize = "clamp(0.1rem, 2.5dvw, 1.75rem)";
        paragraphRef.current.style.marginTop = "clamp(0rem, 1dvw, 0.5rem)";
      } else {
        paragraphRef.current.style.fontSize = "clamp(0.1rem, 4dvw, 2rem)";
        paragraphRef.current.style.marginTop = "clamp(0rem, 2dvw, 1rem)";
      }
      // Mark as sized once calculation is complete
      setIsSized(true);
    }
  }, [isDesktop]);

  return (
    <section className="text-white pt-6 md:pt-4 lg:pt-5 pb-0 relative overflow-hidden bg-transparent">
      <div className="mx-auto px-3 sm:px-4 max-w-[1024px] relative z-10">
        <div className="flex flex-col items-center">
          {/* Chalkboard with text */}
          <div className="relative w-full max-w-3xl mb-0 md:max-w-[60%]">
            <Image
              src="/images/marketing/partners/hero/frame.webp"
              alt=""
              aria-hidden="true"
              width={800}
              height={400}
              className="w-full h-auto"
              priority
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center px-[8%] md:px-[8%] py-12 md:py-8 transform -translate-y-[3%]">
              <div
                className="relative w-full px-4 md:px-4 aspect-[8/1] md:min-h-[50px]"
                style={{
                  opacity: isSized ? 1 : 0,
                  transition: "opacity 0.4s ease-in",
                }}
              >
                {/* Blue highlight positioned behind text */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[calc(100%-1rem)] md:w-[calc(100%-1rem)] h-auto z-0">
                  <Image
                    src="/images/marketing/partners/hero/titleHighlight.webp"
                    alt=""
                    aria-hidden="true"
                    width={800}
                    height={100}
                    className="w-full h-auto"
                    quality={100}
                    unoptimized
                  />
                </div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[calc(100%-5rem)] md:w-[calc(100%-3.5rem)] h-auto z-10">
                  <Image
                    src="/images/marketing/partners/hero/title.svg"
                    alt="Free math resources!"
                    width={600}
                    height={100}
                    className="w-full h-auto"
                    quality={100}
                    unoptimized
                  />
                </div>
              </div>
              <p
                ref={paragraphRef}
                className="font-bold text-center max-w-2xl z-10 relative px-4 md:mt-2"
                style={{
                  opacity: isSized ? 1 : 0,
                  transition: "opacity 0.4s ease-in",
                }}
              >
                If your kids like PlayMath.org,
                <br />
                below are some free high-quality
                <br />
                resources to support their math
                <br />
                education journey.
              </p>
            </div>
          </div>

          {/* Monsters illustration */}
          <div className="relative w-full max-w-2xl -mt-12 md:-mt-16 md:max-w-[35%]">
            <Image
              src="/images/marketing/partners/hero/monsters-on-laptop.webp"
              alt="Friendly monster characters"
              width={800}
              height={400}
              className="w-3/4 md:w-full h-auto mx-auto md:mx-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
